
import { DateTime, Duration } from "luxon";
import { GeoAddressRequest } from "../geo-addresses/geo-address.request";

export interface AddEditLocationRequest {
  id?: string;
  locationId?: string;
  locationName?: string;
  template?:string;
  serviceHoursFrom?: Duration;
  serviceHoursTo?: Duration;
  geoAddress?: GeoAddressRequest;
  address?: string;
  postalCode?: string;
  city?: string;
  country?: string;
  countryCode?: string;
  activityName?: string;
  stopTime?: Duration ;
  serviceTime?: Duration;
  pickupCapacityType1?: number;
  pickupCapacityType2?: number;
  pickupCapacityType3?: number;
  deliveryCapacityType1?: number;
  deliveryCapacityType2?: number;
  deliveryCapacityType3?: number;
  priority?: number;
  qualifications?: string;
  stopNumber?: number;
  sequenceNumber?:number;
  planId?: string;
  jobId?: string;
  precedence?: number;
  customData?: string;
  }
